import { CartItem } from "@/custom-types/Cart";

type ErrorMetaData = {
  cartItems?: Partial<CartItem>;
  reason?: string;
  readableMessage?: string;
};

export class ReservationsApiError extends Error {
  title: string;
  detail: string;
  // metadata is provided for: Axios errors, ReservationsApi::Internal errors
  // and ReservationsApi::External errors.
  metadata: ErrorMetaData | null;
  reason: string | null;
  readableMessage: string;
  constructor({
    message = "There was an error while placing the order",
    metadata = null,
    title = "",
    detail = "",
  }) {
    super(message);
    this.title = title;
    this.detail = detail;
    this.metadata = metadata;
    // The reason should now exist in the metadata as metadata.reason for all
    // errors, but for legacy support, pulling the reason from the error detail
    // will be left in place.
    this.reason =
      (metadata as ErrorMetaData | null)?.reason ||
      detail
        ?.split(" ")
        .find((s) => s.includes("reason="))
        ?.replace("reason=", "") ||
      null;
    // metadata.readableMessage includes consumer facing message to be displayed
    // to the consumer for a given error.
    this.readableMessage = (metadata as ErrorMetaData | null)
      ?.readableMessage as string;
  }
}
